import { useDispatch, useSelector } from "react-redux";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import TimeFrameInformation from "../../Pages/Submitter/WorkPlanEstimatedBudget/TimeFrameInformation";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { useEffect, useState } from "react";
import ImplementationStages from "../../Pages/Submitter/WorkPlanEstimatedBudget/ImplementationStages/imdex";
import ObjectivesAdd from "../../Pages/Submitter/WorkPlanEstimatedBudget/Objectives/ObjectivesAdd";
import Objectives from "../../Pages/Submitter/WorkPlanEstimatedBudget/Objectives";
import ObjectivesAactivities from "../../Pages/Submitter/WorkPlanEstimatedBudget/ObjectivesAactivities";
import BudgetItemsRequestedFromSoman from "../../Pages/Submitter/WorkPlanEstimatedBudget/BudgetItemsRequestedFromSoman";
import ContributionOfSecondTeam from "../../Pages/Submitter/WorkPlanEstimatedBudget/ContributionOfSecondTeam";
import "./style.css";
import {
  SetValidation,
  ValidationBudgetPage,
} from "../../Redux/Reducers/Submitter/BudgetItemsRequestedFromSoman";
import PopupAHSF from "../../Components/PopupAHSF";
import $ from "jquery";
import DetailsBudget from "../../Pages/Submitter/WorkPlanEstimatedBudget/DetailsBudget";
import { useLocation } from "react-router-dom";
import { decryptToken } from "../../Services/Encryption/EncryptionParams";

const WorkPlanEstimatedBudget = () => {
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  console.log(encryptedToken, "slkdslkdlksdl");
  var guid =
    encryptedToken[encryptedToken.length - 1] != null
      ? decryptToken(encryptedToken[encryptedToken.length - 1])
      : null;
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const [
    PopupComponentValidationViewStatus,
    setPopupComponentValidationViewStatus,
  ] = useState(false); // State to control whether the validation popup is visible or not
  const validationList = useSelector(
    (state) => state.BudgetItemsRequestedFromSomanReducers.Validation
  );
  const dispatch = useDispatch();
  const [PopupComponentViewStatus, setPopupComponentViewStatus] =
    useState(false);
  const jsonData = useSelector((state) => state.FetchDataJson.JsonData);
  const closePopupViewComponent = () => {
    // Function to toggle the visibility of the details popup
    if (PopupComponentViewStatus) {
      setPopupComponentViewStatus(false); // Closing the popup
    } else {
      setPopupComponentViewStatus(true); // Opening the popup
    }
  };

  const Validation = async () => {
    const result = await dispatch(
      ValidationBudgetPage({
        applicationInformationId: localStorage.getItem(
          "ApplicationInformationId"
        ),
      })
    );

    if (result.payload.length == 0) {
      $(".ConflictOfInterestAndResearchEthics").trigger("click");
    } else {
      closePopupComponentValidationViewStatus();
    }
  };
  const closePopupComponentValidationViewStatus = () => {
    // Function to toggle the visibility of the validation popup
    if (PopupComponentValidationViewStatus) {
      setPopupComponentValidationViewStatus(false); // Closing the popup
    } else {
      setPopupComponentValidationViewStatus(true); // Opening the popup
    }
  };
const shouldDisableFields = !(

    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.applicationStatusId == "57ca8392-5b8e-4625-8a37-00dfc27d5b28" ? true :
      ActiveRound == ApplicationInformation?.aI_RoundYearId &&
      ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
      window.location.href.includes("manager") == false
  );
  useEffect(() => {
    dispatch(SetValidation([]));
  }, []);
  return ApplicationInformation?.aI_RoundYearId ? (
    <>
      <SharedDiv
        showTitle={true}
        titleName={jsonData ? jsonData?.TimeFrameInformation?.nameAR : ""} // Display the translated title of the time frame information
        child={[
          <TimeFrameInformation
            applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />,
        ]} // Display the TimeFrameInformation component
        showButton={true}
        id_Title="withBtnTitle"
        buttonComponent={
          // Display a button to show the budget summary
          <ButtonAHSF
            id={"btnTitle"}
            type={"submitter"}
            onClick={() => {
              closePopupViewComponent(); // Close the details popup when the button is clicked
            }}
            disabled={false}
            title={"عرض ملخص الموازنة"}
            text={"عرض ملخص الموازنة"}
            show={true}
          />
        }
      />
      <SharedDiv
        showTitle={true}
        titleName={jsonData ? jsonData?.Objectivestitl?.nameAR : ""} // Display the translated title of the time frame information
        child={[
          <Objectives
            applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />,
        ]} // Display the TimeFrameInformation component
      />

      <SharedDiv
        showTitle={true}
        titleName={jsonData ? jsonData?.InfoStage?.nameAR : ""} // Display the translated title of the time frame information
        child={[
          <ImplementationStages
            applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />,
        ]} // Display the TimeFrameInformation component
      />

      <SharedDiv
        showTitle={true}
        titleName={jsonData ? jsonData?.ObjectiveActivate?.nameAR : ""} // Display the translated title of the time frame information
        child={[
          <ObjectivesAactivities
            applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />,
        ]} // Display the TimeFrameInformation component
      />

      <SharedDiv
        showTitle={true}
        titleName={jsonData ? jsonData?.itemsRequestedFromShoman?.nameAR : ""} // Display the translated title of the time frame information
        child={[
          <BudgetItemsRequestedFromSoman
            applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />,
        ]} // Display the TimeFrameInformation component
      />
      <SharedDiv
        showTitle={true}
        titleName={jsonData ? jsonData?.ContributionOfSecondTeam?.nameAR : ""} // Display the translated title of the time frame information
        child={[
          <ContributionOfSecondTeam
            applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />,
        ]} // Display the TimeFrameInformation component
      />

      <PopupAHSF
        title={"تفاصيل الموازنة التقديرية"} // Title for the details popup
        componentBody={
          <DetailsBudget
            applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />
        } // Body of the popup containing the budget details component
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentViewStatus} // Popup open status
        isPopupOpenFunction={closePopupViewComponent} // Function to close the popup
      />
      <PopupAHSF
        title={"يرجى تعبئة الحقول المطلوبة"} // Title for the validation popup
        componentBody={
          <>
            {validationList &&
              validationList.map((ele, ind) => {
                return (
                  <>
                    <p>{ele.message}</p>
                  </>
                );
              })}
          </>
        }
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentValidationViewStatus} // Popup open status
        isPopupOpenFunction={closePopupComponentValidationViewStatus} // Function to close the popup
      />

      {!shouldDisableFields ? (
        <div className="containerButtonMAin">
          <ButtonAHSF onClick={Validation} text={"التالي"} show={true} />
        </div>
      ) : (
        ""
      )}
    </>
  ) : (
    ""
  );
};

export default WorkPlanEstimatedBudget;
